import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { ProjectDetailLayout } from "@/features/projects";

export const Route = createFileRoute("/projects/$projectId")({
  component: () => (
    <PermissionGuard module="projects">
      <ProjectDetailLayout />
    </PermissionGuard>
  ),
});
